import { render } from "./composeWhatsapp.vue?vue&type=template&id=4a04ed4c&scoped=true"
import script from "./composeWhatsapp.vue?vue&type=script&lang=js"
export * from "./composeWhatsapp.vue?vue&type=script&lang=js"

import "./composeWhatsapp.vue?vue&type=style&index=0&id=4a04ed4c&scoped=true&lang=css"
import "./composeWhatsapp.vue?vue&type=style&index=1&id=4a04ed4c&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a04ed4c"]])

export default __exports__